import { logError } from '../logError'
import { path } from './path'

export const onPageStart = (type = '') => {
    try {
        if (path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window)) {
            if (path(['sessionStorage'], window) && typeof window.sessionStorage != 'undefined') {
                sessionStorage.setItem('mobileApp', 'AndroidApp')
                window.localStorage.setItem('DONT_SHOW_COOKIE_BANNER', 'true')
            }
            window.MobileApp?.onPageStart(type)
        }
        if (path(['iosData', 'app-agent'], window) && path(['iosData', 'js-version'], window)) {
            window.localStorage.setItem('DONT_SHOW_COOKIE_BANNER', 'true')
            if (path(['sessionStorage'], window) && typeof window.sessionStorage != 'undefined') {
                sessionStorage.setItem('mobileApp', 'iPhoneApp')
            }
            if (path(['webkit', 'messageHandlers'], window) && window.webkit.messageHandlers[type]) {
                window.webkit.messageHandlers[type].postMessage('')
            }
        }
    } catch (error) {
        logError('onPageStart', error)
    }
}
